
<template>
  <div class="toolTip-box">
    <div class="conttent">
      <h2 class="title">当前操作将更新绑定关系，继续？</h2>
      <div class="pic" :style="{backgroundImage: 'url('+imgSrc+')'}"></div>
      <p class="tip-text" v-text="text()"></p>
      <div class="btn-box">
          <button class="btn no f-l" @click="determine()">确定</button>
          <button class="btn1 no f-l" @click="cancel()">取消</button>
      </div>
    </div>
  </div>
</template>
<script>
var api = process.env.BASE_URL
import axios from 'axios'
import Common from '../../assets/js/common.js'
var _local = window.location.href
var isLocal = Common.getEvn()
var userId=  localStorage.getItem('max_userId')
export default {
  data () {
    return {
      imgSrc: Common.staticHref() + 'img/addfail.png',
      fromPage: this.$route.query.pageName,
      result: this.$route.query.result,
      userId:this.$route.query.userId,
      deviceId:this.$route.query.deviceIdEx,
    }
  },
  methods: {
    cancel () {
      if (this.fromPage === 'Main') {
        sessionStorage.removeItem('isfirst')
        window.location.replace(_local.split('?')[0])
      } else {
        this.$router.push({path: '/'})
      }
    },
    determine () {
      // alert(this.fromPage+"点击事件开始"+this.deviceId)
        if (this.fromPage === 'Main') {
          if (isLocal === 'local') {
            // alert(this.deviceId+'   22222     '+this.userId)
            axios.post( '/Calendar/api/version/reset/device/', {
              'device_ex': this.deviceId,
            })
              .then(this.determincsucess)
              .catch(this.bundleError)}
          else {
               axios.post( api+'/Calendar/api/version/reset/device/', {
              'device_ex': this.deviceId,
            })
                 // alert(this.deviceId,"重置设备ID是")
              .then(this.determincsucess)
              .catch(this.bundleError)
              // alert(this.deviceId,+"v3")
          }
              // alert(9898998)
      } else {
          // alert("点击事件跳转到首页")
        this.$router.push({path: '/'})
      }
    },
    determincsucess(res){
      let _res = res.data
      let result = _res.result
      // alert(result+"++++++++++++++")
      if (result === 0){
        if (isLocal === 'local') {
        // alert(this.deviceId+'   33333     '+this.userId)
        axios.post('/Calendar/api/device/device/Bundle/', {
              'device_id_ex': this.deviceId,
              'user_id': this.userId
              })
        .then(this.bundleSucess)
        .catch(this.bundleError)}
        else {
              axios.post(api+'/Calendar/api/device/device/Bundle/', {
              'device_id_ex': this.deviceId,
              'user_id': this.userId
              })
        .then(this.bundleSucess)
        .catch(this.bundleError)
      }
    }
    else {
        this.bundleError ()
        this.$router.push({path: '/'})

    }},

    bundleSucess (res) {
      // alert(JSON.stringify(res.data))
      let _res = res.data
      let result = _res.result
      // alert(result+"222222222222222"+this.deviceId+3333+this.userId)
      if (result === 0) {
        localStorage.setItem('max_device_id', _res.device_id)
        this.$router.push({path: '/ScanSuccess', query: {pageName: this.fromPage}})
      } else if (result === 4) {
        this.$router.push({path: '/ScanFail2', query: {pageName: this.fromPage,userId:this.userId,deviceIdEx:this.deviceId,result}})
      }
      else if ( result === 2) {
        this.$router.push({path: '/ScanFail', query: {pageName: this.fromPage, result}})
      }
    },
    bundleError () {
      this.toast = this.$createToast({
        txt: '调用接口出错！绑定设备失败',
        type: 'txt'
      })
      this.toast.show()
      setTimeout(() => {
        window.location.replace(_local.split('?')[0])
      }, 1000)
    },
    text () {
      if (this.result === 4) {
        return '设备已被添加'
      } else if (this.result === 2) {
        return '设备号不符合规定'
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.toolTip-box
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0,0,0,.5)
  text-align center
  rowCloCenter()
  .conttent
    background #ffffff
    width 343px
    padding 21px 0
    border-radius 10px
    colmCenter()
    .title
      font-size 16px
      line-height 35px
      color #333333
    .tip-text
      font-size 15px
      color #333333
      line-height 44px
    .pic
      width 166px
      height 135px
      margin 0 auto
      background-repeat no-repeat
      background-position center center
      background-size contain
    .btn-box
      margin 0 auto
      width 300px
      height 40px
      .btn
        float: right;
        width 135px
        height 40px
        text-align center
        background #ededed
        color #ffffff
        font-size 17px
        border-radius 20px
      .btn1
        float: left;
        width 135px
        height 40px
        text-align center
        background #ededed
        color #ffffff
        font-size 17px
        border-radius 20px
      .no
        color #666666
      .yes
        color #0f95e1

</style>



// WEBPACK FOOTER //
// src/pages/ScanFail2/ScanFail2.vue